
import { Options, Vue } from "vue-class-component";
import CookieConsent from './components/CookieConsent.vue';
@Options({})
export default class BaseLayout extends Vue {}
